import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { useExamContext } from "@features/exam/contexts/ExamContext";
import { useAppStore } from "@hooks/useAppStore";
import type { OriginalItemTypes } from "@memorang/types";
import { useCallback } from "react";
import {
	enqueueAssessmentOnLeave,
	markResponseChangedIfGated,
} from "../helpers/summative-assessment-trigger";

const useEnqueueAssessmentOnLeave = () => {
	const { userId } = useAuthContext();
	const {
		currentExamContext: { projectId, organizationId },
	} = useExamContext();
	const testDriver = useAppStore((s) => s.sessionView?.testDriver);

	return useCallback(
		(
			itemId: number | undefined,
			isSummativeTest: boolean | undefined,
			itemType: OriginalItemTypes | undefined,
		) =>
			enqueueAssessmentOnLeave(
				itemId,
				{ userId, projectId, organizationId },
				{ testDriver, isSummativeTest, itemType },
			),
		[userId, projectId, organizationId, testDriver],
	);
};

export const useMarkResponseChangedIfGated = () => {
	const testDriver = useAppStore((s) => s.sessionView?.testDriver);

	return useCallback(
		(
			itemId: number,
			isSummativeTest: boolean | undefined,
			itemType: OriginalItemTypes | undefined,
		) =>
			markResponseChangedIfGated(itemId, {
				testDriver,
				isSummativeTest,
				itemType,
			}),
		[testDriver],
	);
};

export default useEnqueueAssessmentOnLeave;
